// extracted by mini-css-extract-plugin
export default {"currentIcon":"BearerMap_currentIcon__QfaTv","mapContainerClassName":"BearerMap_mapContainerClassName__8357S"};